import moment from 'moment'
import { SHARED_AUTH_COOKIE } from 'src/constants/shared-auth-cookie'

export const getBrowserTimeZone = (ignoreCache) => moment.tz.guess(ignoreCache)

const hasCookie = (name) => document.cookie.split(';').some(c => c.trim().startsWith(name + '='))

export const isImpersonating = () => hasCookie(`${SHARED_AUTH_COOKIE}-imp`) || hasCookie(`${SHARED_AUTH_COOKIE}-admin-imp`)

export const isAdminImpersonating = () => hasCookie(`${SHARED_AUTH_COOKIE}-admin-imp`)

export const getDateInBrowserTimeZone = (date) => {
  return moment(date).tz(getBrowserTimeZone())
}
